import { cx } from "./cx";
import styles from "./ProgressBar.module.css";

export type ProgressContext = "accent" | "low" | "medium" | "high" | "critical" | "info" | "secure";
export type ProgressSize = "mini" | "default";

export interface ProgressBarProps {
  value: number;
  max?: number;
  context?: ProgressContext;
  size?: ProgressSize;
  label?: string;
  className?: string;
}

export function ProgressBar({
  value,
  max = 100,
  context = "accent",
  size = "default",
  label,
  className,
}: ProgressBarProps): JSX.Element {
  const safeMax = max > 0 ? max : 1;
  const ratio = Math.min(1, Math.max(0, value / safeMax));
  const percent = Math.round(ratio * 100);
  return (
    <div
      className={cx(styles.track, styles[size], className)}
      role="progressbar"
      aria-valuenow={value}
      aria-valuemin={0}
      aria-valuemax={safeMax}
      aria-label={label}
    >
      <span className={cx(styles.fill, styles[context])} style={{ width: `${percent}%` }} />
    </div>
  );
}
